import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useGetSiteSettingApiQuery } from "../../../../../Store/Slices/rtk";
import { GradientBorderBox } from "../../../../../Components";

export default function Factor({ order }) {
  const theme = useTheme();
  const gettingTaxCode = useGetSiteSettingApiQuery();
  return (
    <Stack
      sx={{
        width: { xs: "330px", md: "400px" },
        position: "relative",
        height: { xs: "330px", md: "450px" },
        justifyContent: "space-evenly",
        alignItems: "center",
        px: "2rem",
      }}
    >
      {/* price */}
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          color: theme.palette.secondary.main,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "500" , color:theme.palette.background.white}}>مبلغ </Typography>
        <Typography sx={{ fontWeight: "500"  , color:theme.palette.primary.main}}>
          {" "}
          {order?.data?.data?.payment_statics?.cart_total_price?.toLocaleString() ||
            "0"}{" "}
          تومان{" "}
        </Typography>
      </Stack>
      {/* post price */}
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          color: theme.palette.secondary.main,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "500" , color:theme.palette.background.white}}>هزینه ارسال </Typography>
        <Typography sx={{ fontWeight: "500"  , color:theme.palette.primary.main}}>
          {" "}
          {order?.data?.data?.payment_statics?.delivery_price?.toLocaleString() ||
            "0"}{" "}
          تومان{" "}
        </Typography>
      </Stack>
      {/* discount price */}
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          color: theme.palette.secondary.main,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "500", color:theme.palette.background.white }}> مبلغ تخفیف</Typography>
        <Typography sx={{ fontWeight: "500"  , color:theme.palette.primary.main}}>
          {" "}
          {order?.data?.data?.payment_statics?.discount_price?.toLocaleString() ||
            "0"}{" "}
          تومان{" "}
        </Typography>
      </Stack>
      {/* Tax price */}
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          color: theme.palette.secondary.main,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "500" , color:theme.palette.background.white}}> درصد مالیات </Typography>
        <Typography sx={{ fontWeight: "500"  , color:theme.palette.primary.main}}>
          {" "}
          {gettingTaxCode?.data?.data?.tax &&
          gettingTaxCode?.data?.data?.tax != "0"
            ? gettingTaxCode?.data?.data?.tax + " % "
            : "رایگان"}{" "}
        </Typography>
      </Stack>
      {/* ALL price */}
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          color: theme.palette.secondary.main,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "500" , color:theme.palette.background.white}}>مبلغ کل</Typography>
        <Typography sx={{ fontWeight: "500"  , color:theme.palette.primary.main}}>
          {" "}
          {order?.data?.data?.payment_statics?.total_price?.toLocaleString() ||
            "0"}{" "}
          تومان{" "}
        </Typography>
      </Stack>
      <GradientBorderBox
        bgGrad={`linear-gradient(
    270deg,
    ${theme.palette.primary.main} -0%,
    ${theme.palette.background.default} 40%,
    ${theme.palette.background.default} 60%,
   ${theme.palette.background.white} 100%
  )`}
      />
    </Stack>
  );
}
